module.exports = __webpack_public_path__ + "img/section-welcome-back.179010c1.svg";